'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import AdminCleanerTable from '@/app/admin-dashboard/components/AdminCleanerTable';

export default function AdminCleanersPage() {
  return (
    <DashboardLayout role="admin">
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-extrabold text-foreground">Cleaners</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Manage your cleaning team</p>
        </div>
        <AdminCleanerTable />
      </div>
    </DashboardLayout>
  );
}
